/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, february 2021
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

const defaults = {
  networkLogs: [],
};

export interface ActionType {
  type: string;
  payload: any;
}

export default (state = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.ADD_FB_NETWORK_LOG: {
      const { networkLogs } = state;
      const newLines = [...networkLogs];
      if (networkLogs.length >= 1000) {
        newLines.splice(0, 1);
      }
      const { log } = action.payload;
      const { responseURL, payload, response, status } = log;
      let formattedLog = {
        url: responseURL,
        payload: payload && JSON.stringify(payload) || '',
        response: response && JSON.stringify(response) || '',
        status: status,
      }
      return {
        ...state,
        networkLogs: newLines.concat(formattedLog),
      };
    }
    case ActionTypes.CLEAR_FB_NETWORK_LOG: {
      return {
        ...state,
        networkLogs: [],
      };
    }
    default: {
      return { ...state };
    }
  }
};
